import i18next from "i18next";
export const getWaitingRoomMessage = (peopleInQueue) => {
	if (peopleInQueue === 1) {
		return i18next.t("waitingRoom:turnIsNext");
	}

	if (peopleInQueue <= 3) {
		return i18next.t("waitingRoom:turnIsNext");
	}

	if (peopleInQueue <= 5) {
		return i18next.t("waitingRoom:weWillCallYouSoon");
	}

	return i18next.t("waitingRoom:uAreInVirtualQueue");
};
